import { styled } from '../../config'

export const Badge = styled('div', {
  disaply: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '4px 8px',
  gap: '8px',
  borderRadius: '4px',
  boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.05)',
  text: '12',
  background: '#141414',
  color: '$whiteA900',
  WebkitUserSelect: 'none', // Safari
  MozUserSelect: 'none', // Firefox
  MsUserSelect: 'none', // IE10+/Edge
  userSelect: 'none',
  fontWeight: 600,
  variants: {
    type: {
      live: {
        background: '$indigo0700',
        color: '$white'
      },
      secondary: {
        background: '#3E3E3E',
        color: '$whiteA900'
      },
      soldOut: {
        background: '#D9D9D9',
        color: '$whiteA900'
      }
    }
  }
})
